import React, { useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";

import * as styles from "./component.module.scss";

import CarouselDotsTrack from "../DotsTrack";
import clsx from "clsx";

import LeftArrowOn from "../assets/left_arrow_on.svg";
import LeftArrowOff from "../assets/left_arrow_off.svg";
import RightArrowOn from "../assets/right_arrow_on.svg";
import RightArrowOff from "../assets/right_arrow_off.svg";

const Carousel = ({ cards }: { cards?: React.ReactNode[] }) => {
  const [current, setCurrent] = useState(0);

  const cardTrackSwipeable = useSwipeable({
    onSwipedRight: () => setCurrent(Math.max(0, current - 1)),
    onSwipedLeft: () =>
      setCurrent(Math.min(Math.max((cards?.length ?? 0) - 1, 0), current + 1)),
    preventScrollOnSwipe: true
  });
  const cardTrackRef = useRef<HTMLDivElement>(null);
  const [cardTrackResolvedWidth, setCardTrackResolvedWidth] = useState("");

  const cardTrackRefPassthrough = (element: HTMLDivElement) => {
    cardTrackSwipeable.ref(element);
    (cardTrackRef.current as any) = element;
  };

  useEffect(() => {
    if (cardTrackRef.current) {
      setCardTrackResolvedWidth(cardTrackRef.current.offsetWidth + 'px');
    }
  }, [cardTrackRef.current, cardTrackRef.current?.offsetWidth]);

  return (
    <div className={styles.main}>
      <div className={styles.cards}>
        <div
          className={clsx(styles.left, styles.arrow)}
          onClick={() => setCurrent(Math.max(0, current - 1))}
        >
          {current === 0 ? <LeftArrowOff /> : <LeftArrowOn />}
        </div>
        <div
          className={styles.cardsTrack}
          ref={cardTrackRefPassthrough}
          style={{ "--track-card-width": cardTrackResolvedWidth } as any}
        >
          <div
            className={styles.cardsWrapper}
            style={{
              transform: `translate(calc((var(--track-card-width) * -1 - 20px) * ${current}), 0)`,
            }}
          >
            {cards}
          </div>
        </div>
        <div
          className={clsx(styles.right, styles.arrow)}
          onClick={() =>
            setCurrent(
              Math.min(Math.max((cards?.length ?? 0) - 1, 0), current + 1)
            )
          }
        >
          {current === Math.max((cards?.length ?? 0) - 1, 0) ? (
            <RightArrowOff />
          ) : (
            <RightArrowOn />
          )}
        </div>
      </div>
      <div className={styles.dots}>
        <CarouselDotsTrack
          size={cards?.length}
          selectedIndex={current}
          onDotClick={(index) => setCurrent(index)}
        />
      </div>
    </div>
  );
};

export default Carousel;
